export default {
  methods: {
    getRowData(row) {
      return this.table.rowProps[row.id] || {};
    },
    computeRowClsName({ row }) {
      return this.table.rowClassName(row);
    },
    computeRowClasses({ row, rowData, isHover = null }) {
      const { cssClasses } = this;
      return [
        cssClasses.row,
        this.computeRowClsName({ row }),
        {
          [cssClasses.rowHover]: isHover !== null ? isHover : rowData.isHover,
          [cssClasses.rowHighlight]: rowData.isHighlight,
        },
      ];
    },
    computeCellClasses({ column, renderType }) {
      const { cssClasses } = this;
      return [
        cssClasses.cell,
        {
          [cssClasses.hidden]: false,
          [cssClasses.cellEllipsis]: column.ellipsis || false,
          [cssClasses.cellWithExpand]: renderType === 'expand',
        },
      ];
    },
    computeAlignCls({ column, row = {} }) {
      const { cssClasses } = this;
      const classes = [];

      if (row.cellClassName && row.cellClassName[column.key]) {
        classes.push(row.cellClassName[column.key]);
      }
      if (column.className) classes.push(column.className);
      if (column.align) classes.push(`${cssClasses.column}-${column.align}`);
      // if (false) classes.push(cssClasses.hidden)

      return classes;
    },
    setCellWidth(column) {
      let width = '';
      if (column.width) {
        ({ width } = column);
      } else if (this.table.columnsWidth[column.index]) {
        ({ width } = this.table.columnsWidth[column.index]);
      }
      if (width === '0') width = '';
      return width;
    },
  },
};
